import { render, staticRenderFns } from "./ModalAcknowledge.vue?vue&type=template&id=45b9faa5&scoped=true"
import script from "./ModalAcknowledge.vue?vue&type=script&lang=js"
export * from "./ModalAcknowledge.vue?vue&type=script&lang=js"
import style0 from "./ModalAcknowledge.vue?vue&type=style&index=0&id=45b9faa5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9faa5",
  null
  
)

export default component.exports